import {Component, Inject, OnInit} from '@angular/core';
import {Customers} from '../../ecommerce/customers/customers.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DashboardService} from '../../../services/dashboard.service';
import {AlertService} from 'ngx-alerts';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {NgxSpinnerService} from 'ngx-spinner';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-driving-school-students',
  templateUrl: './driving-school-students.component.html',
  styleUrls: ['./driving-school-students.component.scss']
})
export class DrivingSchoolStudentsComponent implements OnInit {
  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  customersData: Customers[];
  validationform: FormGroup;

  customerAddForm: FormGroup;
  customers: any[] = [];
  customerSearch: any = {
    page: 0,
    size: 20,
    search: '',
    channelId: '',
    version: 'v2'
  };

  loggedInUser: any;


  totalRecords = 0;
  pageEvent: PageEvent;

  constructor(private modalService: NgbModal, public formBuilder: FormBuilder, public dashboardService: DashboardService,
              private alertService: AlertService, @Inject(LOCAL_STORAGE) private storage: StorageService,
              private spinner: NgxSpinnerService) {
    this.loggedInUser = storage.get('gs-loggedInUser');
    this.customerSearch.channelId = this.loggedInUser.channelId;
  }

  ngOnInit(): void {
    this.breadCrumbItems = [{label: 'Gypsee'}, {label: 'Students', active: true}];

    this.getCustomers();

    this.buildForm();

  }


  /**
   * Returns form
   */
  get form() {
    return this.customerAddForm.controls;
  }

  /**
   * Modal Open
   * @param content modal content
   */
  openModal(content: any) {
    this.modalService.open(content, {centered: true});
  }

  /**
   * save the contacts data
   */
  saveData() {
    const name = this.validationform.get('name').value;
    const phone = this.validationform.get('phone').value;
    const balance = this.validationform.get('balance').value;
    const email = this.validationform.get('email').value;
    const date = this.validationform.get('date').value;
    if (this.validationform.valid) {
      this.customersData.push({
        name,
        phone,
        balance,
        email,
        date
      });
      this.validationform = this.formBuilder.group({
        name: '',
        phone: '',
        balance: '',
        email: '',
        date: ''
      });
      this.modalService.dismissAll();
    }
    this.submitted = true;
  }

  private getCustomers() {
    this.spinner.show();
    this.dashboardService.getCustomers(this.customerSearch).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.totalRecords = res.totalRecords;
        this.customers = res.customersV2;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  private buildForm() {
    this.customerAddForm = this.formBuilder.group({
      mobileNumber: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.required,
        Validators.pattern(/^[0-9]{10,12}$/)
      ])],
      channelId: [this.loggedInUser.channelId]
    });
  }

  addCustomer() {
    this.submitted = true;
    if (this.customerAddForm.valid) {
      this.spinner.show();
      this.dashboardService.addCustomer(this.customerAddForm.value).pipe(finalize(() => this.spinner.hide())).subscribe(
        (res: any) => {
          this.alertService.success(res.message);
          this.modalService.dismissAll();
          this.getCustomers();
        }, error1 => {
          console.error(error1);
          this.alertService.danger(error1 && error1.message ? error1.message : error1);
        }
      );
    }
  }

  onCustomerSearch(value: any) {
    this.customerSearch.search = value;
    this.getCustomers();
  }

  onResendCodeClick(item: any) {
    this.customerAddForm.get('mobileNumber').setValue(item.userPhoneNumber);
    this.addCustomer();
  }

  getServerData(ev: PageEvent) {
    this.customerSearch.page = ev.pageIndex;
    this.customerSearch.size = ev.pageSize;
    this.getCustomers();
    return ev;
  }

  onBranchSelect(value: any) {
    this.customerSearch.channelId = value.channelId;
    this.getCustomers();
  }

  onWhatsappMessageClick(userPhoneNumber: any) {
    let link = 'https://api.whatsapp.com/send?phone=91' + userPhoneNumber + '&text=';
    let win = window.open(link, '_blank');
    win.focus();
  }
}
